/**
 * @generated SignedSource<<3eab7055940ff6d5d2a8ef56b5bee6d8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type statusCell_softwareCodePage$data = {
  readonly " $fragmentSpreads": FragmentRefs<"prStatusLozenge_softwareCodePage_PRStatusLozengeFragment">;
  readonly " $fragmentType": "statusCell_softwareCodePage";
};
export type statusCell_softwareCodePage$key = {
  readonly " $data"?: statusCell_softwareCodePage$data;
  readonly " $fragmentSpreads": FragmentRefs<"statusCell_softwareCodePage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "statusCell_softwareCodePage",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "prStatusLozenge_softwareCodePage_PRStatusLozengeFragment"
    }
  ],
  "type": "DevOpsPullRequestDetails"
};

(node as any).hash = "95184645f4899acb0fcaf26763746ac5";

export default node;
